import flatpickr from "flatpickr";

flatpickr(".datepicker", {});
